import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { SubContent } from '../types'
import { getOptionsLayout, index2Abc } from '../utils'

@Component
export class SCRenderMixin extends Vue {
  @Prop() public data!: SubContent // prop
  @Prop() public showAnalysis!: boolean
  @Prop() public subIndex!: number
  @Prop() public startIndex!: number
  @Prop() public subContentshowLevelOneIndex!: boolean
  @Prop() public complex!: number
  @Prop() public origin!: string

  public index2Abc = index2Abc

  // 选项布局方式 逐行(option)，2列，3列，4列，同行(option-inline)
  public getOptionsLayout(options: string[]) {
    return getOptionsLayout(options)
  }

  public inlineQIndex(startIndex: number, subIndex: number) {
    let str = this.origin
      ? `<a href="javascript: 0;" class="q-paper-info">（${this.origin}）</a>`
      : ''
    if (this.subContentshowLevelOneIndex) {
      // 子题显示一级编号
      if (startIndex < 0) return '' + str
      else return '<span class="q-number-index">' + (startIndex + 1) + '、</span>' + str
    } else if (this.complex) {
      return '<span class="q-number-index">(' + (subIndex + 1) + ') </span>'
    } else {
      return ''
    }
  }

  public get showOptions() {
    if (!this.data || !(this.data as any).options) return false
    return (this.data as any).options.length > 0
  }
}
